export default __webpack_public_path__ + "static/media/fv_help.f70d5dd5.svg";